import { Box, Typography, CircularProgress, IconButton } from "@mui/material";
import { DollarIcon, DownloadIcon, FolderIcon } from "assets/styles/icons";
import { useProgress } from "context/ProgressProvider";
import { Formik } from "formik";
import { useEffect, useState } from "react";
import { saveAs } from "file-saver";
import { useDispatch, useSelector } from "react-redux";
import { AppPrimaryButton } from "shared/components/AppComponents";
import { ProfileActions } from "state/profile/Action";
import UploadDocuments from "./upload/UploadDocuments";
import SignersList from "./list/SignersList";
import Toast from "shared/helpers/Toast";
import { LoanService } from "services/LoanService";

const AgreementsSigning = () => {
  const dispatch = useDispatch();
  const { handleUpdateUserLoan, currentProfile } = useProgress();

  const [step, setStep] = useState(null);
  const [isLoadingSign, setIsLoadingSign] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [loadingForm, setLoadingForm] = useState(true);
  const [documentsData, setDocumentsData] = useState(null);

  const actionOnDowload = async (): Promise<void> => {
    setIsDownloading(true);
    if (!documentsData) return;
    const saveFile: any = saveAs(
      documentsData.signedDocumentUrl,
      `${documentsData.signedDocumentName}.pdf`,
    );
    await saveFile;
    setTimeout(() => {
      setIsDownloading(false);
    }, 500);
  };

  const generateDocumentMapping = (callback: any): void => {
    LoanService.generateDocumentMapping({ loanId: currentProfile.loadId })
      .then((response: any) => {
        callback(true);
      })
      .catch((error: any) => {
        callback();
      })
      .finally(() => {});
  };

  const handleUpdateLoan = (callback) => {
    LoanService.getLoanReview(currentProfile.loadId)
      .then((response) => {
        let data = response.data.data;
        if (data?.loanDetails?.isDocumentMappingCompleted === false) {
          callback();
          return;
        }
        setLoadingForm(false);
        handleUpdateUserLoan(response);
        if (data.signedDocumentName && data.signedDocumentUrl) {
          setDocumentsData({
            signedDocumentName: data.signedDocumentName,
            signedDocumentUrl: data.signedDocumentUrl,
          });
        }
        if (data.signerStatus === "completed") {
          setStep(2);
          return;
        }
        if (data.documentStatus === "completed") {
          setStep(1);
          return;
        }
        setStep(0);
      })
      .catch((error) => {})
      .finally(() => {
        setLoadingForm(false);
      });
  };

  useEffect(() => {
    if (step === 2) {
      dispatch(
        ProfileActions.setSblProfile({
          isPayment: true,
        }),
      );
    } else {
      dispatch(
        ProfileActions.setSblProfile({
          isPayment: false,
        }),
      );
    }
  }, [step]);

  useEffect(() => {
    const applyTheme = new Promise((resolve, reject) => {
      dispatch(
        ProfileActions.setSblProfile({
          isPayment: true,
        }),
      );
      resolve(true);
    });

    applyTheme.then(() => {
      handleUpdateLoan(() => {
        generateDocumentMapping(() => handleUpdateLoan(() => {}));
      });
    });
  }, []);

  return (
    <>
      {loadingForm && (
        <Box
          sx={{
            textAlign: "center",
            height: "calc(100vh - 50%)",
            alignContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {step === 0 && <UploadDocuments setStep={setStep} />}
      {/* {step === 1 && (
        <Box>
          <Typography variant="h2">Ready to Sign?</Typography>
          <Typography variant="h3" fontWeight={400}>
            Your documents are ready. Please review and sign them to activate
            your loan. This will only take a couple of minutes.
          </Typography>
          <ul style={{ paddingInlineStart: "25px" }}>
            <li>
              <Typography variant="h3" fontWeight={400}>
                Loan Agreement
              </Typography>
            </li>
            <li>
              <Typography variant="h3" fontWeight={400}>
                Letter of Offer
              </Typography>
            </li>
          </ul>

          <Box sx={{ marginTop: "2rem" }}></Box>
          <Formik
            enableReinitialize
            validateOnMount
            onSubmit={(formValues, formik) => {
              setIsLoadingSign(true);
              handleEsign();
            }}
            initialValues={{
              none: "",
            }}
          >
            {({ handleSubmit, errors }) => {
              console.log(errors);
              return (
                <form autoComplete="off">
                  <Box mt={3}>
                    <AppPrimaryButton
                      title="Sign now with eSign"
                      isLoading={isLoadingSign}
                      loadingText="Please wait.."
                      disabled={isLoadingSign}
                      onClick={handleSubmit}
                    />
                  </Box>
                </form>
              );
            }}
          </Formik>
          <img
            src="/images/poweredDoxAI.png"
            height={42}
            width={75}
            style={{ marginTop: "24px" }}
          />
        </Box>
      )}

      {step === 2 && (
        <Box py={10}>
          <iframe
            src="https://sign.doxai.co/login"
            title="DoxAI"
            width="100%"
            height="500px"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          <Box mt={3}>
            <AppPrimaryButton
              title="Continue"
              onClick={() => setStep((prev) => prev + 1)}
            />
          </Box>
        </Box>
      )} */}

      {step === 1 && <SignersList />}

      {step === 2 && (
        <>
          <Box sx={{ textAlign: "center" }} mt={3}>
            <img src="/images/payment-success.gif" width={120} height={120} />
            <Typography variant="h2">Documents signed</Typography>
            <Typography variant="h3" fontWeight={400}>
              Your documents have been successfully signed, we’ll begin <br />
              processing the loan from our end
            </Typography>

            {/* Box data */}
            <Box
              sx={{
                border: "1px solid #E5E5E5",
                borderRadius: "16px",
                padding: "32px",
                width: "auto",
                justifySelf: "center",
              }}
              mt={3}
            >
              <Typography variant="h3" sx={{ textAlign: "left" }}>
                What’s next
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: "16px",
                  alignItems: "center",
                  textAlign: "left",
                  width: "100%",
                }}
                mt={3}
                py={2}
              >
                <FolderIcon />
                <Box sx={{ width: "90%" }}>
                  <Typography
                    variant="h3"
                    fontWeight={400}
                    lineHeight={"normal"}
                  >
                    Process application
                  </Typography>
                  <Typography
                    variant="h4"
                    fontWeight={400}
                    lineHeight={"normal"}
                    color="#474747"
                  >
                    Our team will review your application and verify everything{" "}
                    <br />
                    is in correct order.
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: "16px",
                  alignItems: "center",
                  textAlign: "left",
                  width: "100%",
                }}
                mt={3}
                py={2}
              >
                <DollarIcon />
                <Box sx={{ width: "90%" }}>
                  <Typography
                    variant="h3"
                    fontWeight={400}
                    lineHeight={"normal"}
                  >
                    Funds allocation
                  </Typography>
                  <Typography
                    variant="h4"
                    fontWeight={400}
                    lineHeight={"normal"}
                    color="#474747"
                  >
                    After approval, the funds will be transferred to your <br />
                    nominated account
                  </Typography>
                </Box>
              </Box>
              <Typography
                variant="h4"
                fontWeight={200}
                mt={3}
                color="#848484"
                sx={{ textAlign: "left" }}
              >
                We’ll notify you at each step so you’re always in the loop
              </Typography>
            </Box>

            <IconButton
              className="mt-8 align-center"
              onClick={actionOnDowload}
              disableFocusRipple
              disableRipple
              disableTouchRipple
            >
              {!isDownloading && (
                <>
                  <DownloadIcon />
                  <Typography
                    variant="h4"
                    fontWeight={400}
                    color={"primary"}
                    className="ml-2"
                  >
                    Download documents
                  </Typography>{" "}
                </>
              )}
              {isDownloading && (
                <Box className="">
                  <CircularProgress size={30} />
                </Box>
              )}
            </IconButton>
          </Box>
        </>
      )}
    </>
  );
};

export default AgreementsSigning;
